import React from "react";
import { Card, Badge, Button } from "antd";
import ShowResource from "./ShowResource";
import EditResource from "./EditResourceButton";
import DeleteResource from "./DeleteResourceButton";
import { Grid } from "@material-ui/core";

export const ResourceCard = ({ item }) => {
    return (
        <Card
            title={<Badge status="processing" text={item.name} />}
            style={{
                marginBottom: 15,
                minWidth: 300,
                boxShadow: "1px 1px 1px #9E9E9E",
                borderRadius: "5px",
            }}
            bordered={true}
            extra={<Button type="primary">Resource</Button>}
            actions={[
                <ShowResource item={item} key="view" />,
                <EditResource item={item} key="edit" />,
                <DeleteResource item={item} key="delete" />,
            ]}
        >
            <Grid container direction="column" justify="center" alignItems="center">
                <h1>{item.name}</h1>
            </Grid>
        </Card>
    );
};

export default ResourceCard;
